import { Space, Button, Popconfirm, Switch } from "antd";
import { afterSaleStatus } from "utility/options/index";

export const Columns = ({
  handleEdit,
  handleDelete,
  handleCopy,
  taxOptions,
  onCreateAfterSaleOpen,
  onVipTicketOpen,
}) => [
    {
      title: "退換票狀態",
      dataIndex: "afterSalePolicy",
      key: "afterSalePolicy",
      render: (text, record) =>
        (record?.afterSaleStatus &&
          afterSaleStatus.find((item) => item.value === text)?.label) ||
        "-",
    },
    {
      title: "票券名稱",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "原始數量",
      dataIndex: "originalQuantity",
      key: "originalQuantity",
    },
    {
      title: "剩餘數量",
      dataIndex: "remainQuantity",
      key: "remainQuantity",
    },
    {
      title: "票價",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "稅務項目",
      dataIndex: "taxId",
      key: "taxId",
      render: (text) => {
        if (taxOptions.length > 0) {
          let result = taxOptions.filter((t) => t.id == text)[0];
          return result?.name;
        } else return "-";
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        return (
          <Space>
            <Button type="primary" onClick={() => handleEdit(record)}>
              編輯
            </Button>
            <Popconfirm
              title="Delete the task"
              description="Are you sure to delete this task?"
              onConfirm={() => handleDelete(record)}
              onCancel={(e) => console.log("e", e)}
              okText="Yes"
              cancelText="No"
            >
              <Button type="default" className="bg-red-500 text-white">
                刪除
              </Button>
            </Popconfirm>
            <Button
              type="primary"
              className="bg-green-500 text-white border-green-500 hover:bg-green-600 hover:border-green-600"
              onClick={() => handleCopy(record)}
              loading={record.isCopyBtnLoading}
            >
              複製
            </Button>
            <Button
              type="primary"
              className="bg-orange-400 text-white"
              onClick={() => onCreateAfterSaleOpen(record)}
            >
              新增退換票
            </Button>
            <Button
              type="primary"
              className="bg-black text-white"
              onClick={() => onVipTicketOpen(record)}
            >
              免費票
            </Button>
          </Space>
        );
      },
    },
  ];
